import React from "react";

import { Chip } from "@mui/material";

import { OPCOES_SITUACAO_AGENDAMENTO } from "../constants/agendamentoOptions";

export default function BadgeSituacaoAgendamento({ situacao }) {
  if (!situacao) return null;

  const opcao = OPCOES_SITUACAO_AGENDAMENTO.find(
    (item) => item.value === situacao,
  );

  return (
    <Chip
      label={opcao?.label ?? situacao}
      size="small"
      sx={{
        backgroundColor: opcao?.backgroundColor ?? "#EEEEEE",

        color: opcao?.color ?? "#333344",

        fontWeight: 600,

        fontSize: "11px",

        borderRadius: "6px",
      }}
    />
  );
}
